/* eslint-disable jsx-a11y/anchor-is-valid */
import {useRootStore} from "store/useRootStore"
import {observer} from "mobx-react"
import {Map, MapMarker} from "react-kakao-maps-sdk"
import {useEffect, useState} from "react"
import {PathTracking} from "dto/path-tracking/path-tracking"
import {PathListView} from "pages/admin/event/PathListView"
import {DeviceSearchWindow} from "pages/admin/event/DeviceSearchWindow"
import {downloadEmergencyExcel} from "../../../api/path-tracking.api";
import {NotificationType, showNotification} from "../../../common/Notification";
import {isValidCoordinate, getCoordinateErrorMessage} from "../../../utils/coordinate-validator";

const centerPosition = {lat: 35.8242238, lng: 127.1479532}
export const PathList = observer(() => {
    // const [showRegisterDeviceWindow, setShowRegisterDeviceWindow] = useState(false)
    const [euiKeyword, setEuiKeyword] = useState<string | undefined>()
    const [showSearchWindow, setShowSearchWindow] = useState<boolean>(false)
    const [currentLatLng, setCurrentLng] = useState<{lat: number, lng: number}|null>()
    const {
        adminStore: {
            pathTrackingStore: {
                page,
                setPage,
                size,
                setKeyword,
                showOnlyEmergency,
                setShowOnlyEmergency,
            }
        }
    } = useRootStore()
    const [selectedPath, selectPath] = useState<PathTracking | undefined>(undefined)
    useEffect(() => {
        if (!selectedPath) return
        if (isValidCoordinate(selectedPath)) {
            setCurrentLng({lat: selectedPath.lat, lng: selectedPath.lng})
        } else {
            showNotification(getCoordinateErrorMessage(selectedPath), NotificationType.ERROR)
        }
    }, [selectedPath]);


    const currentLatLng1 = selectedPath ? {lat: selectedPath.lat || 0, lng: selectedPath.lng || 0} : null
    const setSearchKeyword = () => {
        setKeyword(euiKeyword)
        setPage(0)
    }

    return (
        <div className="admin-container">
            <div className="level ">
                <div className="level-left">
                    <h5 className="is-size-3 has-text-weight-bold">경로 추적 정보 로그</h5>
                </div>
                <div className="level-right">
                    <div className="level-item">
                        <label className="label mt-3">
                            <input type="checkbox" onChange={(e) => {
                                setShowOnlyEmergency(!showOnlyEmergency)
                            }} checked={showOnlyEmergency}/>
                            <span className="ml-2 mr-2">넘어짐 로그만 표시</span>
                        </label>
                        {showOnlyEmergency && (
                            <button className="button  mt-2 is-success mr-2"
                                    onClick={() => downloadEmergencyExcel()}>
                                넘어짐로그 다운로드
                            </button>
                        )}
                        <button className="button  mt-2 is-primary" title="eui 를 모르시면 검색하세요"
                                onClick={() => setShowSearchWindow(true)}>
                        사용자(장치) 찾기
                        </button>
                    </div>
                    <div className="level-item input-search-box5">
                        <div className="btn-search" onClick={() => setSearchKeyword()}>
                            <i className="fa fa-search has-text-info"/>
                        </div>
                        <input className="input" type="text" placeholder="단말기 eui"
                               defaultValue={euiKeyword} onChange={e => setEuiKeyword(e.target.value)}
                        />
                    </div>
                </div>
            </div>
            <div className="admin-panel admin-body columns">
                <div className="column is-two-thirds">
                    <PathListView page={page} size={size} setPage={setPage}
                                  selectPath={selectPath}
                                  selectedPath={selectedPath}
                    />
                </div>
                <div className="column" style={{position: "relative"}}>
                    <Map center={currentLatLng ? currentLatLng : centerPosition}
                         style={{position: "absolute", top: 0, right: 0, bottom: 0, left: 0}} level={7}
                         onCreate={(map) => setTimeout(() => map.relayout(), 500)}
                    >
                        {currentLatLng && (
                            <MapMarker position={currentLatLng}/>
                        )}
                    </Map>
                </div>
            </div>
            {showSearchWindow && (
                <DeviceSearchWindow
                    onSelect={(eui) => {
                        setEuiKeyword(eui)
                    }}
                    show={showSearchWindow}
                    close={() => setShowSearchWindow(false)}
                    title="단말검색"
                />
            )}
        </div>
    )
})


